function toggleDropdown(button) {
    var content = button.nextElementSibling;
    content.style.display = content.style.display === "block" ? "none" : "block";
    button.querySelector('.arrow').textContent = content.style.display === "block" ? "▼" : "▶";
  }

  // On page load, ensure all dropdowns are closed
  document.addEventListener("DOMContentLoaded", function() {
    const contents = document.querySelectorAll(".dropdown-content");
    contents.forEach(content => {
      content.style.display = "none";
    });
  });